<script>
import { GlFormGroup, GlCollapsibleListbox } from '@gitlab/ui';
import { s__ } from '~/locale';
import { DISMISSAL_REASONS } from 'ee/vulnerabilities/constants';
import HelpPopover from '~/vue_shared/components/help_popover.vue';

export default {
  components: {
    GlFormGroup,
    GlCollapsibleListbox,
    HelpPopover,
  },
  inject: ['dismissalDescriptions'],
  props: {
    value: {
      type: String,
      required: false,
      default: null,
    },
    state: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    toggleText() {
      return this.value ? DISMISSAL_REASONS[this.value] : this.$options.i18n.selectReason;
    },
    isInvalid() {
      return !this.value && this.state === false;
    },
  },
  i18n: {
    dismissalReason: s__('SecurityReports|Dismissal reason (required)'),
    selectReason: s__('SecurityReports|Select dismissal reason'),
    fieldRequired: s__('SecurityReports|A dismissal reason is required.'),
  },
  items: Object.entries(DISMISSAL_REASONS).map(([value, text]) => ({
    value,
    text,
  })),
};
</script>

<template>
  <gl-form-group
    label-for="dismissal-reason"
    :invalid-feedback="$options.i18n.fieldRequired"
    :state="!isInvalid"
  >
    <template #label>
      {{ $options.i18n.dismissalReason }}
      <help-popover>
        <div v-for="reason in $options.items" :key="reason.value">
          <strong>{{ reason.text }}</strong>
          <p>{{ dismissalDescriptions[reason.value] }}</p>
        </div>
      </help-popover>
    </template>
    <gl-collapsible-listbox
      id="dismissal-reason"
      data-testid="dismissal-reason"
      :items="$options.items"
      :selected="value"
      :toggle-text="toggleText"
      :variant="isInvalid ? 'danger' : 'default'"
      category="secondary"
      @select="$emit('input', $event)"
    />
  </gl-form-group>
</template>
